// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1F5E2","inputWrap":"Table_inputWrap__MYuqt","col":"Table_col__irPMH","bmiTooltip":"Table_bmiTooltip__23XAA"};